import { Reducer } from 'react'
import { Api } from '../../types/api'
import { ApplicationState } from './AppContext'
import Context = Api.Context

export const APPLICATION_ACTION_CHANGE = 'APPLICATION_ACTION_CHANGE'

interface ApplicationActionChange {
    type: typeof APPLICATION_ACTION_CHANGE
    applicationContext: Context | null
}

export type ApplicationActionTypes = ApplicationActionChange

export const applicationReducer: Reducer<ApplicationState, ApplicationActionTypes> = (
    applicationState: ApplicationState,
    action: ApplicationActionTypes
) => {
    switch (action.type) {
        case APPLICATION_ACTION_CHANGE:
            applicationState.applicationContext = action.applicationContext
            return applicationState
        default:
            return applicationState
    }
}
